import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  AfterViewInit,
  OnDestroy,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Map, NavigationControl, Marker } from "maplibre-gl";
import moment from "moment";
import { EmployeeDetailsService } from "../_services/employee-details.service";
import { DatePipe } from "@angular/common";
import maplibregl from "maplibre-gl";
import { GeoJSON } from "geojson";

@Component({
  selector: "app-field-track",
  templateUrl: "./field-track.component.html",
  styleUrls: ["./field-track.component.scss"],
})
export class FieldTrackComponent implements OnInit {
  map: Map | undefined;
  @ViewChild("map")
  private mapContainer!: ElementRef<HTMLElement>;
  deviceDetails: any;
  customdate = new FormControl(moment());
  formGroup: any;
  formBuilder: any;
  codes: any;
  mapArray: any;
  constructor(
    private employeeDetails: EmployeeDetailsService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      code: new FormControl("", [Validators.required]),
      date: new FormControl("", [Validators.required]),
    });
    this.employeeDetails.getEmployeeDetails().subscribe(
      (response: any) => {
        if (response && response.msg && Array.isArray(response.msg)) {
          this.codes = response.msg;
          console.log(this.codes);
        }
      },
      (error: any) => {
        console.error("Error fetching employee details:", error);
      }
    );
  }

  ngAfterViewInit() {
    // new Marker({color: "#FF0000"})
    //   .setLngLat([139.7525,35.6846])
    //   .addTo(this.map);
    // new Marker({color: "#FF0000"})
    //   .setLngLat([-0.1276,51.5074])
    //   .addTo(this.map);
    // const greenMarkerImage = new Image();
    //   greenMarkerImage.src = '/assets/images/green-marker.png';
    // this.map.on('load', () => {
    //     this.map.addImage('green-marker', greenMarkerImage);
    //     const markerColor =  'green-marker' ;
    //     const geojsonFeature = {
    //         'type': 'Feature',
    //         'properties': {
    //             'description': this.deviceDetails.device_id,
    //             'icon': markerColor,
    //         },
    //         'geometry': {
    //             'type': 'Point',
    //             'coordinates': [
    //               this.deviceDetails.device_long.toString(),
    //               this.deviceDetails.device_lat.toString()
    //             ],
    //         },
    //     };
    //     this.map.addSource('places', {
    //         'type': 'geojson',
    //         'data': {
    //             'type': 'FeatureCollection',
    //             'features': [geojsonFeature],
    //         },
    //     });
    //     this.map.addLayer({
    //         'id': 'places',
    //         'type': 'symbol',
    //         'source': 'places',
    //         'layout': {
    //             'icon-image': ['get', 'icon'],
    //             'icon-overlap': 'always',
    //             'icon-size': 1,
    //         },
    //     });
    //     const popup = new maplibregl.Popup({
    //         closeButton: false,
    //         closeOnClick: false,
    //     });
    //     this.map.on('mouseenter', 'places', (e: maplibregl.MapLayerMouseEvent) => {
    //         this.map.getCanvas().style.cursor = 'pointer';
    //         const coordinates = (e.features[0].geometry as any).coordinates.slice();
    //         const device_id = e.features[0].properties['description'];
    //         while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
    //             coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
    //         }
    //         // Populate the popup with device_id and set its coordinates
    //         // based on the feature found.
    //         popup.setLngLat(coordinates).setHTML(`<strong>${device_id}</strong>`).addTo(this.map);
    //     });
    //     this.map.on('mouseleave', 'places', () => {
    //         this.map.getCanvas().style.cursor = '';
    //         popup.remove();
    //     });
    // });
  }

  ngOnDestroy() {
    this.map?.remove();
  }

  onSubmit() {
    // Handle form submission
    if (this.formGroup.valid) {
      this.formGroup.value.date = this.datePipe.transform(
        this.formGroup.value.date,
        "yyyy-MM-dd"
      );
      console.log(this.formGroup.value);
      this.employeeDetails
        .getTrackDetails(this.formGroup.value)
        .subscribe((response: any) => {
          console.log(response.msg);
          this.mapArray = response.msg;
          const initialState = { lng: 80.2707, lat: 13.0827, zoom: 10 };

          this.map = new Map({
            container: this.mapContainer.nativeElement,
            style: `https://api.maptiler.com/maps/streets-v2/style.json?key=rfbtBDxb0VjtfmJzd4VA`,
            center: [initialState.lng, initialState.lat],
            zoom: initialState.zoom,
            maxZoom:30
          });
          this.map?.addControl(new NavigationControl(), 'top-right');

         
          if (this.mapArray) {
            // Create an array to store the coordinates of the LineString
            const lineCoordinates: [number, number][] = [];
        
            this.mapArray.forEach((data: any, index: number) => {
              console.log(data)
                if (!isNaN(data.latitude) && !isNaN(data.longitude)) {
                    const lngLat: [number, number] = [parseFloat(data.longitude), parseFloat(data.latitude)];
        
                    // Add marker to the map with the LngLat object
                    const markerColor = (index === 0) ? '#FF0000' : (index === this.mapArray.length - 1) ? '#00FF00' : '#0000FF';
                    ;
                    const marker = new maplibregl.Marker({ color: markerColor })
                        .setLngLat(lngLat)
                        .addTo(this.map!);
        
                    // Remove default SVG marker
                    if (marker) {
                        const defaultSvg = marker.getElement().querySelector('svg');
                        if (defaultSvg) {
                            defaultSvg.remove();
                        }
                    }
        
                    // Create and append custom marker icon
                    const iconElement = document.createElement('img');
                    iconElement.src = (markerColor === '#FF0000') ? '/assets/images/marker-32.png' : (markerColor === '#00FF00') ? '/assets/images/marker_read.png' : '/assets/images/red-dot.png';
                    iconElement.width = (markerColor === '#FF0000') ? 40 : (markerColor === '#00FF00') ? 40 : 25;
                    iconElement.height = (markerColor === '#FF0000') ? 40 : (markerColor === '#00FF00') ? 40 : 25;
                    marker.getElement().appendChild(iconElement);
        
                    
                    lineCoordinates.push(lngLat);
        
                    // Create a popup instance
                    const popup = new maplibregl.Popup({ offset: [0, -10] });
        
                    // Add mouseenter event listener to show popup
                    marker.getElement().addEventListener('mouseenter', () => {
                        if (this.map && this.map.getCanvas()) {
                            this.map.getCanvas().style.cursor = 'pointer';
                        }
        
                        popup.setLngLat(lngLat).setHTML(`<strong>${data.date_time}</strong>`).addTo(this.map!);
                    });
        
                    // Add mouseleave event listener to remove popup
                    marker.getElement().addEventListener('mouseleave', () => {
                        if (this.map && this.map.getCanvas()) {
                            this.map.getCanvas().style.cursor = '';
                        }
        
                        popup.remove();
                    });
                }
            });
        
            // Create a GeoJSON Feature object for the LineString
            const lineStringFeature = {
                type: 'Feature',
                geometry: {
                    type: 'LineString',
                    coordinates: lineCoordinates
                },
                properties: {} // You can add properties here if needed
            };
        
            // Add LineString layer to the map
            this.map.on('style.load', () => {
              // This callback will be executed once the map style has finished loading
              
              // Add your layer creation code here, after the map style has loaded
              this.map?.addLayer({
                  id: 'line-layer',
                  type: 'line',
                  source: {
                      type: 'geojson',
                      data: {
                          type: 'Feature',
                          geometry: {
                              type: 'LineString',
                              coordinates: lineCoordinates // Assuming lineCoordinates contains your line coordinates
                          }
                      }
                  },
                  layout: {
                      'line-cap': 'round',
                      'line-join': 'round'
                  },
                  paint: {
                      'line-color': 'blue',
                      'line-width': 5
                  }
              });
          });
        }
        
        });
    }
  }
}